import useConfirmBeforeLeave from './useConfirmBeforeLeave';

export default useConfirmBeforeLeave;
